"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("./..");

var CounterFieldSet = function CounterFieldSet(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      label = _ref.label,
      variant = _ref.variant,
      min = _ref.min,
      max = _ref.max,
      step = _ref.step,
      disabled = _ref.disabled;

  var increase = function increase() {
    onChange(Math.min(value + step, max));
  };

  var decrease = function decrease() {
    onChange(Math.max(value - step, min));
  };

  var handleCounterManualChange = (0, _react.useCallback)(function (strValue) {
    var intValue = parseInt(strValue, 10);
    onChange(Math.max(Math.min(intValue, max), min));
  }, [onChange, max, min]);
  return /*#__PURE__*/_react.default.createElement(_.FieldSet, {
    label: label,
    className: "CounterFieldSet"
  }, /*#__PURE__*/_react.default.createElement(_.IconButton, {
    size: "s",
    variant: variant,
    icon: "fas fa-minus",
    onClick: decrease,
    disabled: disabled || value === min
  }), /*#__PURE__*/_react.default.createElement(_.TextField, {
    type: "number",
    min: min,
    max: max,
    variant: variant,
    value: value,
    disabled: disabled,
    onChange: handleCounterManualChange
  }), /*#__PURE__*/_react.default.createElement(_.IconButton, {
    size: "s",
    variant: variant,
    icon: "fas fa-plus",
    onClick: increase,
    disabled: disabled || value === max
  }));
};

CounterFieldSet.propTypes = {
  value: _propTypes.default.number,
  onChange: _propTypes.default.func,
  label: _propTypes.default.string,
  variant: _propTypes.default.oneOfType([_propTypes.default.oneOf(['fill', 'outline', 'clear']), _propTypes.default.string]),
  min: _propTypes.default.number,
  max: _propTypes.default.number,
  step: _propTypes.default.number,
  disabled: _propTypes.default.bool
};
CounterFieldSet.defaultProps = {
  variant: 'outline',
  value: 0,
  min: 0,
  max: 5,
  step: 1
};
CounterFieldSet.displayName = 'CounterFieldSet';
var _default = CounterFieldSet;
exports.default = _default;